const PHOTO_ROUTE_SEGMENTS = 3;

export const normalizePhotoFilename = (filename) => {
    if (!filename || typeof filename !== "string") return "";

    const sanitized = filename
        .trim()
        .replace(/\\/g, "/")
        .replace(/^\/+/, "")
        .replace(/^uploads\//i, "");

    if (!sanitized) return "";

    const parts = sanitized.split("/").filter(Boolean);
    if (parts.length < PHOTO_ROUTE_SEGMENTS) return "";

    return parts
        .slice(-PHOTO_ROUTE_SEGMENTS)
        .map((part) => encodeURIComponent(part))
        .join("/");
};

export const buildSinglePhotoUrl = (fileOrFilename) => {
    const filename = typeof fileOrFilename === "string"
        ? fileOrFilename
        : fileOrFilename?.filename;

    const normalizedFilename = normalizePhotoFilename(filename);
    return normalizedFilename ? `/photos/single/${normalizedFilename}` : "";
};
